import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-add",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class AddButtonComponent extends EceButtonComponent {
  icon = "plus-outline";
}
